import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const VarificationPopUp = (props) => {
  const {
    message,
    setVarificationPopUp,
    varificationPopUp,
    setVarificationMessage,
  } = props;

  const handleOk = () => {
    setVarificationPopUp(false);
    setVarificationMessage('');
  };

  return (
    <Dialog fullWidth={true} maxWidth={'xs'} open={varificationPopUp}>
      <DialogContent dividers>
        <Typography variant='h6'>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleOk}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VarificationPopUp;
